import { NgModule } from "@angular/core";
import { StatsComponent } from "./stats/stats.component";
import { MoodDistributionForEntirePeriodComponent } from "./graphs/mood-distribution-for-entire-period/mood-distribution-for-entire-period.component";
import { WordcloudComponent } from "./graphs/wordcloud/wordcloud.component";
import { UsageComponent } from "./graphs/usage/usage.component";
import { MoodDistributionByDayComponent } from './graphs/mood-distribution-by-day/mood-distribution-by-day.component';
import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { SavedFilterComponent } from "../filter/saved-filter/saved-filter.component";
import { AnnouncementComponent } from "../shared/ui/announcement/announcement.component";
import { MatSelectModule } from "@angular/material/select";
import { HighchartsChartComponent } from "highcharts-angular";

@NgModule({
    declarations: [
      StatsComponent,
      MoodDistributionForEntirePeriodComponent,
      MoodDistributionByDayComponent,
      WordcloudComponent,
      UsageComponent
    ],
  imports: [
    AnnouncementComponent,
    SavedFilterComponent,
    CommonModule,
    TranslateModule,
    OverlayModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    HighchartsChartComponent,
  ]
})
  export class TmAnalyticsModule{
  }